export default __webpack_public_path__ + "assets/4b6acd15f29a45c4af70956573773fc5.png";